import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout/index' // 页面布局
import Blank from '@/layout/blank' // 页面布局

/* Router Modules */
//import componentsRouter from './modules/components'
//import chartsRouter from './modules/charts'
//import tableRouter from './modules/table'
//import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
    path: '/login',
    component: Blank,
    redirect: '/login/index',
    children: [{
      path: 'index',
      component: () => import('@/views/login/index'),
      name: 'Login',
      meta: {
        title: '登录',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'reginfo',
      component: () => import('@/views/login/reginfo'),
      name: 'RegInfo',
      meta: {
        title: '登记信息',
        icon: 'dashboard',
        affix: true
      }
    }]
  }, {
    path: '/',
    component: Layout,
    redirect: '/addcard',
    children: [{
      path: 'login',
      component: () => import('@/views/login/index'),
      name: 'Login',
      meta: {
        title: '登录',
      }
    }, {
      path: 'addcard',
      component: () => import('@/views/buy/addcard'),
      name: 'Addcard',
      meta: {
        title: '开卡/设备',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'mine',
      component: () => import('@/views/mine/index'),
      name: 'Mine',
      meta: {
        title: '我的',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'order',
      component: () => import('@/views/order/index'),
      name: 'Order',
      meta: {
        title: '订单',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'coupon',
      component: () => import('@/views/coupon/index'),
      name: 'Coupon',
      meta: {
        title: '优惠券',
        icon: 'dashboard',
        affix: true
      }
    }]
  },

  {
    path: '/card',
    component: Layout,
    redirect: '/card/index',
    children: [{
      path: 'index',
      component: () => import('@/views/cards/index'),
      name: 'Cards',
      meta: {
        title: '卡/设备包',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'detail',
      component: () => import('@/views/cards/detail'),
      meta: {
        title: '卡主页',
        icon: 'dashboard',
        affix: true
      }
    }]
  },
  {
    path: '/wifi',
    component: Layout,
    children: [{
      path: 'detail',
      component: () => import('@/views/cards/wifi'),
      meta: {
        title: '设备主页',
        icon: 'dashboard',
        affix: true
      }
    }]
  },
  {
    path: '/buy',
    component: Blank,
    redirect: '/buy/index',
    children: [{
      path: 'index',
      component: () => import('@/views/buy/index'),
      name: 'Buy',
      meta: {
        title: '订购套餐',
        icon: 'dashboard',
        affix: true
      }
    }, {
      path: 'charge',
      component: () => import('@/views/buy/charge'),
      name: 'Charge',
      meta: {
        title: '预存余额',
        icon: 'dashboard',
        affix: true
      }
    }]
  },

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [

]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js